/**
 * wujiebantu App 桌面图标
 */
export default function AppLaunch() {
  return (
    <svg width="45" height="44" viewBox="0 0 45 44" fill="none">
      <path
        d="M0.5 8C0.5 3.58172 4.08172 0 8.5 0H36.5C40.9183 0 44.5 3.58172 44.5 8V36C44.5 40.4183 40.9183 44 36.5 44H8.5C4.08172 44 0.5 40.4183 0.5 36V8Z"
        fill="url(#paint0_radial_6795_133037)"
      />
      <path
        d="M34.7679 32.3177L31.8699 32.8893V16.313L20.9477 12.5558V35.0446L20.4672 35.1374L18.2099 35.5834L18.0352 35.618V8.65479L20.9477 9.60319L31.8699 13.1602L34.7679 14.1049V25.424V32.3177Z"
        fill="#FFD600"
      />
      <path
        d="M18.0495 32.7054V35.618L7.85547 25.424H18.0349V27.6084H12.9525L18.0459 32.7018L18.0495 32.7054Z"
        fill="white"
        fillOpacity="0.2"
      />
      <path
        d="M31.8675 29.4597V32.8893L26.5557 27.6084H20.9453V25.424H27.8317L31.8675 29.4597Z"
        fill="white"
        fillOpacity="0.2"
      />
      <defs>
        <radialGradient
          id="paint0_radial_6795_133037"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(-19.7925 -40.2232) rotate(53.9943) scale(114.971)"
        >
          <stop />
          <stop offset="1" stopColor="#262525" />
        </radialGradient>
      </defs>
    </svg>
  )
}
